import { useEffect, useMemo, useState } from "react";
import { FaFolderOpen, FaInfoCircle } from "react-icons/fa";
import { AppModal } from "../../../../../_CORE/APP/Templates/_UI/Modal/_index";
import { AppButton } from "../../../../../_CORE/APP/Templates/_UI/Button/_index";
import { FormGrid, FieldInput, FieldTextarea, FieldColor } from "../../../../../_CORE/APP/Templates/_UI/Form/_index";

const EMPTY = { name: "", description: "", color: "#e83a52" };
const valuesFrom = (group) => group ? { name: group.name ?? "", description: group.description ?? "", color: group.color ?? "#e83a52" } : EMPTY;

export const LibraryGroupModal = ({ isOpen, onClose, group = null, onSave, isLoading = false }) => {
    const [values, setValues] = useState(EMPTY);
    useEffect(() => { if (isOpen) setValues(valuesFrom(group)); }, [isOpen, group]);
    const dirty = useMemo(() => JSON.stringify(values) !== JSON.stringify(valuesFrom(group)), [values, group]);
    const edit = !!group?.id;
    const field = (name) => ({ id: name, name, value: values[name] ?? "", onChange: (event) => setValues((current) => ({ ...current, [name]: event.target.value })) });
    const submit = async () => {
        if (!values.name.trim()) return;
        const ok = await onSave?.({ name: values.name.trim(), description: values.description.trim(), color: values.color || undefined });
        if (ok !== false) onClose?.();
    };
    return (
        <AppModal isOpen={isOpen} onClose={onClose} size="lg" isDirty={dirty}
            title={edit ? "Editar grupo" : "Nuevo grupo"}
            description="Agrupa tus PDFs por tema, tecnologia, curso o cualquier criterio que te sirva."
            footer={<><AppButton variant="ghost" tone="neutral" onClick={onClose}>Cancelar</AppButton><AppButton onClick={submit} isLoading={isLoading}>{edit ? "Guardar cambios" : "Crear grupo"}</AppButton></>}>
            <div className="LStudio__library_modal_stack">
                <div className="LStudio__library_helpbox"><FaInfoCircle /><div><strong>Organizacion segura</strong><p>Si borras un grupo, sus PDFs pasan a "Sin grupo". Los archivos no se eliminan.</p></div></div>
                <FormGrid columns={2}>
                    <FieldInput {...field("name")} label="Nombre del grupo" placeholder="Arquitectura de software" isRequired span={2} />
                    <FieldTextarea {...field("description")} label="Descripcion" placeholder="Libros y referencias..." rows={4} span={2} />
                    <FieldColor {...field("color")} label="Color identificador" showSwatches={false} />
                    <div className="LStudio__library_group_preview" style={{ "--library-group-color": values.color || "#e83a52" }}><span><FaFolderOpen /></span><div><strong>{values.name || "Tu grupo"}</strong><small>Vista previa</small></div></div>
                </FormGrid>
            </div>
        </AppModal>
    );
};
